import { useCallback, useMemo, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslations } from '@lang';

type UseNotesPreferencesParams = {
  form: UseFormReturn<any>;
  fieldName?: string;
};

export function useNotesPreferences({ form, fieldName = 'notes' }: UseNotesPreferencesParams) {
  const { t } = useTranslations();
  const [noteValue, setNoteValue] = useState('');

  const handleFreeTextChange = useCallback(
    (_categoryId: string, value: string) => {
      setNoteValue(value);
      form.setValue(fieldName, value);
    },
    [form, fieldName]
  );

  const preferenceCategories = useMemo(
    () => [
      {
        id: 'notes',
        label: t('additional.notes'),
        isFreeText: true,
        freeTextPlaceholder: t('booking.additionnalNotesPlaceholder'),
        freeTextValue: noteValue,
      },
    ],
    [t, noteValue]
  );

  return {
    handleFreeTextChange,
    preferenceCategories,
  };
}
